<template>
	<div class="header_paged">
		<!--顶部-->
		<div class="header_page">
			<div class="header">
				<!--沸鲸logo-->
				<div @click="toHomePage()" class="header_fjLogo">
					<img src="../assets/anda_logo.png"/>
				</div>
				<!--导航栏-->
				<div class="page_list">
					<div v-bind:class="{'page_sel':title=='index'}" @click="changePage('/')">首页</div>
					<div v-bind:class="{'page_sel':title=='aboutUs'}" @click="changePage('/aboutUs')">关于我们</div>
					<div v-bind:class="{'page_sel':title=='talentTemplate'}" @click="changePage('/talentTemplate')">人才板块</div>
					<div v-bind:class="{'page_sel':title=='projectPlate'}" @click="changePage('/projectPlate')">项目板块</div>
					<div v-bind:class="{'page_sel':title=='consultant'}" @click="changePage('/consultant')">专家顾问</div>
					<div v-bind:class="{'page_sel':title=='news'}" @click="changePage('/news')">新闻资讯</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			title: {
				type: String,
				default: '/'
			}
		},
		data() {
			return {
			}
		},
		created: function() {
		},
		methods: {
			showInfo(){
				this.$message('个人中心相关页面建议在PC端浏览');
			},
			backPage(){
				this.$router.go(-1);//返回上一层
			},
//			点击logo回到首页
			toHomePage(){
				this.$router.push({
					path: '/'
				});
			},
			changePage(Event) {
				this.$router.push({
					path: Event
				});
			},

		}
	}
</script>

<style scoped="scoped">
	.header_paged{
		padding-top: 74px;
		
	}
	.header_page{
		position: fixed;
		top: 0px;
		left: 0px;
		z-index: 999;
		width: 100%;
		height: 70px;
		background-color: #fff;
		box-shadow: 0px 4px 10px rgba(150, 150, 150, 0.1);
	}
	.header{
		width: 1200px;
		height: 70px;
		margin: 0 auto;
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		align-items: center;
		
	}
	.header .header_fjLogo{
		width: 155px;
		height: 46px;
		margin-right: 68px;
	}
	.page_list{
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		align-items: center;
		
	}
	.page_list>div{
		position: relative;
		line-height: 21px;
		color: #51565D;
		margin-right: 40px;
		cursor: pointer;
	}
	.page_list>div::after{
		content: "";
    	display: none;
    	width: 100%;
    	height: 2px;
    	background-color: #3370ff;
   	 	position: absolute;
    	left: 0px;
    	bottom: -24px;   	
	}	
	
	.page_list>div:hover{
		color: #3370ff;
	}
	.page_list>div:hover::after{
		display: block;
	}
	.page_list>.page_sel{
		position: relative;
		line-height: 21px;
		color: #3370ff;
		margin-right: 40px;
	}
	.page_list>.page_sel::after{
		content: "";
    	display: block;
    	width: 100%;
    	height: 2px;
    	background-color: #3370ff;
   	 	position: absolute;
    	left: 0px;
    	bottom: -24px;  
	}
</style>


// WEBPACK FOOTER //
// src/components/header.vue